import { render, staticRenderFns } from "./DataTableNew.vue?vue&type=template&id=766efc78&functional=true&"
import script from "./DataTableNew.vue?vue&type=script&lang=js&"
export * from "./DataTableNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports